export default [
  {
    path: "/activity-2023/share",
    component: () =>
      import(
        /* webpackChunkName: 'share-router' */ "@/views/common/share/index.vue"
      ),
    children: [
      {
        path: "/activity-2023/play-feeling/result/:id",
        component: () =>
          import(
            /* webpackChunkName: 'share-play-feeling-result' */ `@/views/common/play-feeling/components/Main.vue`
          ),
        props: (route) => ({
          isShare: true,
          id: Number(route.params.id),
        }),
      },
    ],
  },
];
